import BulkBackgroundCheckDrawer from 'src/pages/ApplicantsPage/components/BulkActionsDrawers/BulkBackgroundCheckDrawer'
import BulkCallDrawer from 'src/pages/ApplicantsPage/components/BulkActionsDrawers/BulkCallDrawer'
import BulkEmailDrawer from 'src/pages/ApplicantsPage/components/BulkActionsDrawers/BulkEmailDrawer'
import BulkLessonAndCourseDrawer from 'src/pages/ApplicantsPage/components/BulkActionsDrawers/BulkLessonAndCourseDrawer'
import BulkMemberAssignmentDrawer from 'src/pages/ApplicantsPage/components/BulkActionsDrawers/BulkMemberAssignmentDrawer'
import BulkRecruiterAssignmentDrawer from 'src/pages/ApplicantsPage/components/BulkActionsDrawers/BulkRecruiterAssignmentDrawer'
import BulkSignDrawer from 'src/pages/ApplicantsPage/components/BulkActionsDrawers/BulkSignDrawer'
import BulkSmsDrawer from 'src/pages/ApplicantsPage/components/BulkActionsDrawers/BulkSmsDrawer'
import BulkStatusDrawer from 'src/pages/ApplicantsPage/components/BulkActionsDrawers/BulkStatusDrawer'

import {
  BULK_ACTION_NAME,
  type BulkActionName,
  type BulkActionResult,
  type SelectedApplicant,
} from './bulkActiontypes'

type Props = {
  activeActionId: BulkActionName | null
  selectedApplicants: SelectedApplicant[]
  setSelectedApplicants: (next: SelectedApplicant[]) => void
  onClose: () => void
  refetchQueries?: any[]
  setLoading?: (loading: boolean) => void
  setResults?: (results: BulkActionResult[] | null) => void
}

const BulkActionDrawerHost = ({
  activeActionId,
  selectedApplicants,
  setSelectedApplicants,
  onClose,
  refetchQueries = [],
  setLoading,
  setResults,
}: Props) => {
  if (!activeActionId) return null

  const commonBulkActionProps = {
    applicants: selectedApplicants,
    setApplicants: setSelectedApplicants,
    onClose,
    setLoading,
    setResults,
  }

  switch (activeActionId) {
    case BULK_ACTION_NAME.SMS:
      // Preserve existing behavior: ApplicantsPage did not pass refetchQueries
      return <BulkSmsDrawer {...commonBulkActionProps} />
    case BULK_ACTION_NAME.Email:
      // Preserve existing behavior: ApplicantsPage did not pass refetchQueries
      return <BulkEmailDrawer {...commonBulkActionProps} />
    case BULK_ACTION_NAME.Call:
      return (
        <BulkCallDrawer
          {...commonBulkActionProps}
          refetchQueries={refetchQueries}
        />
      )
    case BULK_ACTION_NAME.Stage:
      return (
        <BulkStatusDrawer
          {...commonBulkActionProps}
          refetchQueries={refetchQueries}
        />
      )
    case BULK_ACTION_NAME.Sign:
      return (
        <BulkSignDrawer
          {...commonBulkActionProps}
          refetchQueries={refetchQueries}
        />
      )
    case BULK_ACTION_NAME.BackgroundCheck:
      return (
        <BulkBackgroundCheckDrawer
          {...commonBulkActionProps}
          refetchQueries={refetchQueries}
        />
      )
    case BULK_ACTION_NAME.AssignTraining:
      return (
        <BulkLessonAndCourseDrawer
          {...commonBulkActionProps}
          refetchQueries={refetchQueries}
        />
      )
    case BULK_ACTION_NAME.RecruiterAssignment:
      return (
        <BulkRecruiterAssignmentDrawer
          {...commonBulkActionProps}
          refetchQueries={refetchQueries}
        />
      )
    case BULK_ACTION_NAME.MemberAssignment:
      return (
        <BulkMemberAssignmentDrawer
          {...commonBulkActionProps}
          refetchQueries={refetchQueries}
        />
      )
    default:
      return null
  }
}

export default BulkActionDrawerHost
